<template>
  <v-container>
    <h1 class="text-center text-uppercase">CREATE USER</h1>
    <div>
      <v-form ref="form">
        <v-text-field
          label="User Name"
          prepend-inner-icon="mdi-account"
          v-model="name"
          :rules="[RULES.required]"
        ></v-text-field>
        <v-text-field
          label="CONTACT NUMBER"
          prepend-inner-icon="mdi-phone"
          v-model="phone"
          :rules="[RULES.required,RULES.mobile]"
        ></v-text-field>
        <v-autocomplete
          v-model="role"
          :rules="[RULES.required]"
          :items="['ADMIN','STAFF']"
          label="Role"
          prepend-inner-icon="mdi-account-hard-hat"
        ></v-autocomplete>
        <v-text-field
          label="User ID"
          prepend-inner-icon="mdi-account-key"
          v-model="uid"
          :rules="[RULES.required]"
        ></v-text-field>
        <v-text-field
          :type="show ? 'text' : 'password'"
          :append-icon="show ? 'mdi-eye-outline':'mdi-eye-off'"
          @click:append="show = !show"
          label="User Password"
          prepend-inner-icon="mdi-lock"
          v-model="password"
          :rules="[RULES.required]"
        ></v-text-field>
        <v-btn block color="primary1" dark @click="createUser">CREATE</v-btn>
      </v-form>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      uid: "",
      password: "",
      name: "",
      show: false,
      role: "STAFF",
      phone: "",
      company: {}
    };
  },
  computed: {
    ...mapGetters(["RULES"])
  },
  created() {
    this.company = this.$session.get("company");
  },
  methods: {
    ...mapActions(["NEW_USER"]),
    createUser() {
      if (this.$refs.form.validate()) {
        this.$store.commit("SET_LOADING", true);
        this.NEW_USER({
          name: this.name,
          password: this.password,
          role: this.role,
          phone: this.phone,
          userid: this.uid,
          company: this.company.id
        }).then(() => {
          this.name = "";
          this.password = "";
          this.role = "";
          this.phone = "";
          this.uid = "";
          this.$store.commit("SET_LOADING", false);
        });
      }
    }
  }
};
</script>

<style>
</style>